(function($) {
  // Initialize
  var kkbbReplaceInterval = 20000;

  // Initialize KKBB list
  var kkbbList = [
    'Olivier.J', 'Élodie.P', 'Delphine.L', 'Thierry.L', 'Isabelle.C', 'Vincent.P',
    'Éric.C', 'Benoit.W', 'Penelope.L', 'Anne-Claire.B', 'Angélique.B', 'Jean-Pierre.F',
    'Luc.P', 'Christophe.B', 'Ewald.F', 'Agnès.L', 'Matthieu.G', 'Antoine.J',
    'Emilien.M', 'Raphaelle.F', 'Sidney.B', 'Gilles.R', 'Adeline.C', 'Quentin.W',
    'Karine.P', 'Marilyne.H', 'Benjamin.P', 'Mélodie.E', 'Rachel.B', 'Bénédicte.B',
    'Michael.V', 'Fabien.B', 'Hugo.O', 'Nicolas.B', 'Éva.G', 'Lucie.M', 'Sébastien.D',
    'Sarah.L', 'Clément.P', 'Siham.C', 'Lisa.E', 'Agathe.C', 'Maxime.D', 'Xavier.B',
    'Hortense.T', 'Marion.K', 'Coralie.D', 'Jérémy.G', 'Annick.E'
  ];

  /**
   * Get a random KKBB user name
   * @return (string) Random user name
   */
  function getRandomKkbbName() {
    var max = kkbbList.length;
    var randomIndex = Math.floor(Math.random() * (max - 1));
    if (randomIndex < 0) {
      randomIndex = 0;
    } else if (randomIndex > max) {
      randomIndex = max;
    }
    return kkbbList[randomIndex];
  }

  // First load of content
  var _container = $('.js-kkbb-container');
  var content = _container.attr('data-content');
  content = content.replace('__firstname1__', getRandomKkbbName());
  content = content.replace('__firstname2__', getRandomKkbbName());
  _container.html(content);
  var _namesContainer = [
    $('strong:first', _container),
    $('strong:last', _container)
  ];

  function updateName(index) {
    setTimeout(function() {
      _namesContainer[index].html(getRandomKkbbName());
      updateName(index);
    }, kkbbReplaceInterval);
  }

  // Update names with intervals
  updateName(0);
  setTimeout(function() {
    updateName(1);
  }, kkbbReplaceInterval / 2);

})(jQuery);
